export const PG_FEATURESERV_URL = `${window.location.origin}/features`;
